import Factory from '../factory';

const schema = Factory.schema('hero-text');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('heading').setType(String).setValue('Heading');
attributes.prop('text').setType(String).setValue('Text...');

export default schema;
